import styled from 'styled-components';

const PageLayoutWithSidebarWrapper = styled.div`
    border: 1px solid #D3D3D3;
    border-radius: 20px;
    opacity: 1;
    padding:20px;
    .clearance-btn{
        width: fit-content;
    }
    .shares-form{
        overflow:scroll;
    }
    .shares-min-width{
        min-width:450px;
    }

`;

export default PageLayoutWithSidebarWrapper;